// Temperature changes

// 0: year
// 1: no_smoothing - "Annual mean"
// 2: lowess - "Lowess smoothing"

export default [
	// [1939, -0.02, 0.03],
	// [1940, 0.13, 0.07],
	// [1941, 0.19, 0.09],
	// [1942, 0.07, 0.11],
	// [1943, 0.09, 0.1],
	// [1944, 0.21, 0.08],
	// [1945, 0.09, 0.04],
	// [1946, -0.07, 0.01],
	// [1947, -0.03, -0.04],
	// [1948, -0.11, -0.07],
	// [1949, -0.11, -0.08],
	// [1950, -0.17, -0.08],
	// [1951, -0.07, -0.07],
	// [1952, 0.01, -0.07],
	// [1953, 0.08, -0.07],
	// [1954, -0.13, -0.06],
	// [1955, -0.14, -0.06],
	// [1956, -0.19, -0.05],
	// [1957, 0.05, -0.04],
	// [1958, 0.06, -0.01],
	// [1959, 0.03, 0.01],
	[1960, -0.03, 0.03],
	[1961, 0.06, 0.01],
	[1962, 0.03, -0.01],
	[1963, 0.05, -0.03],
	[1964, -0.2, -0.04],
	[1965, -0.11, -0.05],
	[1966, -0.06, -0.06],
	[1967, -0.02, -0.05],
	[1968, -0.08, -0.03],
	[1969, 0.05, -0.02],
	[1970, 0.03, 0],
	[1971, -0.08, 0],
	[1972, 0.01, 0],
	[1973, 0.16, 0],
	[1974, -0.07, 0.01],
	[1975, -0.01, 0.02],
	[1976, -0.1, 0.04],
	[1977, 0.18, 0.07],
	[1978, 0.07, 0.12],
	[1979, 0.16, 0.16],
	[1980, 0.26, 0.2],
	[1981, 0.32, 0.21],
	[1982, 0.14, 0.22],
	[1983, 0.31, 0.21],
	[1984, 0.16, 0.21],
	[1985, 0.12, 0.22],
	[1986, 0.18, 0.24],
	[1987, 0.32, 0.27],
	[1988, 0.39, 0.31],
	[1989, 0.27, 0.33],
	[1990, 0.45, 0.33],
	[1991, 0.4, 0.33],
	[1992, 0.22, 0.33],
	[1993, 0.23, 0.33],
	[1994, 0.32, 0.34],
	[1995, 0.45, 0.37],
	[1996, 0.33, 0.4],
	[1997, 0.46, 0.42],
	[1998, 0.61, 0.44],
	[1999, 0.38, 0.47],
	[2000, 0.39, 0.5],
	[2001, 0.54, 0.52],
	[2002, 0.63, 0.55],
	[2003, 0.62, 0.58],
	[2004, 0.53, 0.61],
	[2005, 0.68, 0.62],
	[2006, 0.63, 0.62],
	[2007, 0.66, 0.63],
	[2008, 0.54, 0.64],
	[2009, 0.66, 0.64],
	[2010, 0.72, 0.65],
	[2011, 0.61, 0.67],
	[2012, 0.65, 0.7],
	[2013, 0.68, 0.74],
	[2014, 0.75, 0.79],
	[2015, 0.9, 0.83],
	[2016, 1.01, 0.87],
	[2017, 0.92, 0.91],
	[2018, 0.85, 0.92],
	[2019, 0.98, 0.93],
	[2020, 1.01, 0.93],
	[2021, 0.84, 0.93],
];